import { ExternalLink } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

// Product Card Component
export const ProductCard = ({ product }) => {
  const { t } = useLanguage();
  return (
    <a
      href={product.url}
      target="_blank"
      rel="noopener noreferrer"
      className="block p-3 rounded-lg transition-all duration-300 hover:scale-[1.02] hover:shadow-md"
      style={{ backgroundColor: 'rgba(163, 177, 138, 0.08)', border: '1px solid rgba(163, 177, 138, 0.2)' }}
      data-testid="product-card"
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <h6 className="font-heading text-sm font-semibold mb-1" style={{ color: '#1A3C34' }}>
            {product.nombre}
          </h6>
          <p className="font-body text-xs mb-2" style={{ color: '#6B705C' }}>
            {product.descripcion}
          </p>
          <p className="font-body text-xs" style={{ color: '#A3B18A' }}>
            <strong>{t.usage}</strong> {product.uso}
          </p>
        </div>
        <ExternalLink className="w-4 h-4 flex-shrink-0 mt-1" style={{ color: '#A3B18A' }} />
      </div>
    </a>
  );
};
